import axios from 'axios';
import { req } from './axiosFun';



export const campList = (params) => { return axios.get("/customer/listClzCust") };
export const campListSave  = (params) => { return req("post", "/customer/addClzCust", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteClzCust", params) };








// WEBPACK FOOTER //
// ./src/api/campsMG16.js